import { GetStaticProps, InferGetStaticPropsType } from "next";
import { ParsedUrlQuery } from "querystring";

import {
  Button,
  colors,
  getCdnImageSrc,
  Image,
  NextLink,
  responsive,
  VStack,
} from "goi_common";

import CLOSED_SANGJO_LIST from "@/constants/closed_sangjo.json";
import ClosedSangjoLayout from "@/containers/closed/ClosedSangjoLayout";
import Footer from "@/containers/Home/components/Footer";

interface Params extends ParsedUrlQuery {
  id: string;
}

export const getStaticPaths = async () => {
  const paths = CLOSED_SANGJO_LIST.map((closedSangjo) => {
    return {
      params: {
        id: String(closedSangjo.id),
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { id } = params as Params;

  const closedSangjoData = CLOSED_SANGJO_LIST.find(
    (closedSangjo) => closedSangjo.id === Number(id)
  );

  const companyName = closedSangjoData?.companyname || "";

  const title = `${companyName} 피해 보상금 수령하기 - [똑똑한 소비자를 위한 상조, 고이 프라임]`;
  const description = `${companyName} 상조 폐업에 따른 보상금 수령 방법과, 합리적으로 장례를 치를 수 있는 방법을 안내합니다. 간편하게 ${companyName} 폐업 보상금 받고, 저렴하게 상조 가입하세요.`;
  const keywords = `${companyName} 폐업, ${companyName} 보상금, ${companyName} 상조 폐업, ${companyName} 보상금 수령, ${companyName} 내상조그대로, 폐업 상조, 저렴한 상조 가입, 100원 상조, 상조 가입 방법`;

  return {
    props: {
      closedSangjoData,
      pageDescription: description,
      pageOgTitle: title,
      pageOgDescription: description,
      pageKeywords: keywords,
      pageOgImage: "",
    },
  };
};

const ClosedSangjoGuidePage = ({
  closedSangjoData,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { companyname, depositAgency } = closedSangjoData;

  return (
    <>
      <ClosedSangjoLayout
        style={responsive({
          padding: { base: "30px 20px", md: "60px 0px 90px" },
        })}
      >
        <h1 className="subtitle_21_b brown650">
          <b className="orange650">{companyname}</b> 피해보상금 수령하기
        </h1>
        <p className="body_14_m brown650" css={{ margin: "28px 0 8px" }}>
          {companyname}에 가입한 가입자는 {depositAgency}에서 납입 금액의 50%를{" "}
          <b>{"‘소비자피해보상금'"}</b>으로 돌려받을 수 있습니다. 피해보상금
          돌려받으시고, 보다 합리적인 가격의 상조 서비스를 이용해보세요.
        </p>
        <p className="caption_12_m brown650" css={{ margin: "0px 0 20px" }}>
          (*단, 보상 기한이 종료된 경우, 보상금을 받지 못할 수 있으니 반드시
          확인하시길 바랍니다.)
        </p>

        <Image
          src={getCdnImageSrc(`direct/closed/closed-image.png`)}
          alt={`${companyname} 피해보상금 비교`}
          css={{ borderRadius: "8px" }}
        />

        <VStack alignItems="center" width="100%" margin="12px 0 20px">
          <NextLink
            href={`/`}
            css={{ width: "100%" }}
            event={{
              newGtm: { path: "closed", trigger_and_target: "uv_home" },
            }}
          >
            <Button
              className="subtitle_16_b white"
              css={{
                height: "56px",
                width: "100%",
                background: colors.orange650,
                borderRadius: "8px",
              }}
            >
              100원 상조 더 알아보기
            </Button>
          </NextLink>
        </VStack>
      </ClosedSangjoLayout>
      <Footer />
    </>
  );
};

export default ClosedSangjoGuidePage;
